import * as Yup from "yup";

export const profileSchema = Yup.object({
  name: Yup.string().required("Name is Required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phoneNumber: Yup.string()
    .matches(/^\d{7,}$/, "Phone Number must be at least 7 digits")
    .required("Phone Number is required"),
  address: Yup.string().required("Address 1 is required"),
  address2: Yup.string().required("Address 2 is required"),
  address3: Yup.string().required("Address 2 is required"),
  country: Yup.string().required("Country is required"),
});
